export default { sha: '1337032990d6573936e20f10cc2dd0f2f0ef8719', buildNumber: 'undefined' }
